// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mnd-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4rem;
}

.btn {
  border: none;
  padding: 1.5rem 6rem;
  background-color: rgba(255, 255, 255, 0.899);
  border-radius: 1.5rem;
  text-decoration: none;
}

.products {
  border: 0.2rem solid #274e13;
  font-family: Inter;
  color: #274e13;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.products:hover {
  color: white;
  cursor: pointer;
  background-color: #274e13;
}

.orders {
  border: 0.2rem solid #ce7e00;
  font-family: Inter;
  color: #ce7e00;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.orders:hover {
  color: white;
  cursor: pointer;
  background-color: #ce7e00;
}

.settings {
  border: 0.2rem solid;
  font-family: Inter;
  color: #343a40;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.settings:hover {
  color: white;
  cursor: pointer;
  background-color: #343a40;
}

.map {
  border: 0.2rem solid;
  font-family: Inter;
  color: #2A81CB;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.map:hover {
  color: white;
  cursor: pointer;
  background-color: #2A81CB;
}

.signout {
  border: 0.2rem solid;
  font-family: Inter;
  color: #801e17;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.signout:hover {
  color: white;
  cursor: pointer;
  background-color: #343a40;
}

@media (max-width: 1077px) {
  .mnd-nav {
    gap: 0rem;
    flex-direction: column;
  }
  .products,
  .orders,
  .settings {
    font-size: 1.4rem;
  }
  .btn {
    padding: 0.5rem 8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NavigationBar/NavigationBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,4CAA4C;EAC5C,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;IACE,SAAS;IACT,sBAAsB;EACxB;EACA;;;IAGE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".mnd-nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4rem;\n}\n\n.btn {\n  border: none;\n  padding: 1.5rem 6rem;\n  background-color: rgba(255, 255, 255, 0.899);\n  border-radius: 1.5rem;\n  text-decoration: none;\n}\n\n.products {\n  border: 0.2rem solid #274e13;\n  font-family: Inter;\n  color: #274e13;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.products:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #274e13;\n}\n\n.orders {\n  border: 0.2rem solid #ce7e00;\n  font-family: Inter;\n  color: #ce7e00;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.orders:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #ce7e00;\n}\n\n.settings {\n  border: 0.2rem solid;\n  font-family: Inter;\n  color: #343a40;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.settings:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #343a40;\n}\n\n.map {\n  border: 0.2rem solid;\n  font-family: Inter;\n  color: #2A81CB;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.map:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #2A81CB;\n}\n\n.signout {\n  border: 0.2rem solid;\n  font-family: Inter;\n  color: #801e17;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.signout:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #343a40;\n}\n\n@media (max-width: 1077px) {\n  .mnd-nav {\n    gap: 0rem;\n    flex-direction: column;\n  }\n  .products,\n  .orders,\n  .settings {\n    font-size: 1.4rem;\n  }\n  .btn {\n    padding: 0.5rem 8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
